module.exports = __webpack_public_path__ + "img/live-not-start.78632979.png";